import { render, staticRenderFns } from "./Flash2Cards.vue?vue&type=template&id=67862603&scoped=true&"
var script = {}
import style0 from "./Flash2Cards.vue?vue&type=style&index=0&id=67862603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67862603",
  null
  
)

export default component.exports